import React, { Component } from 'react';

import ReactCodeInput from 'react-verification-code-input';

export default (props) => (
  <ReactCodeInput
    type={props.type || 'number'}
    fields={props.fields || 4}
    onChange={props.onChange}
    onComplete={props.onComplete}
    loading={props.loading || false}
    className={props.className || ''}
    style={{
      direction: 'ltr',
    }}
  />
);
